import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { css, html, nothing } from "lit";
import { getClasses, getWrapperClasses, getMessageClasses } from "./utils.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./textarea.selectors.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfTextarea = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.value = "";
    this.dsf_error = false;
    this.dsf_success = false;
    this.disabled = false;
    this.readonly = false;
    this.dsf_resizable = false;
    this.dsf_auto_height = false;
    this.dsf_rows = 3;
    this.dsf_size = "medium";
    this.autofocus = false;
  }
  onInput(event) {
    this.value = event.target.value;
    this.emit({ name: "input", payload: this.value });
  }
  renderLabel() {
    return this.dsf_label ? html`<label id="label" data-skeleton>${this.dsf_label}</label>` : nothing;
  }
  get rowCount() {
    if (this.dsf_auto_height) {
      const newlines = this.value.split(/\r\n|\r|\n/).length;
      if (newlines > this.dsf_rows) {
        return newlines;
      }
    }
    return this.dsf_rows;
  }
  render() {
    const classes = getClasses(this);
    const wrapperClasses = getWrapperClasses(this);
    const messageClass = getMessageClasses(this);
    const message = this.dsf_message ? html`<span class="${messageClass}" data-skeleton>${this.dsf_message}</span>` : nothing;
    return html` <div class=${wrapperClasses}>
      ${this.renderLabel()}
      <span data-skeleton>
        <textarea
          aria-labelledby="label"
          .value=${this.value}
          class=${classes}
          name=${ifDefined(this.dsf_name)}
          ?autofocus=${this.autofocus}
          ?readonly=${this.readonly}
          ?disabled=${this.disabled}
          placeholder=${ifDefined(this.dsf_placeholder)}
          cols=${ifDefined(this.dsf_cols)}
          rows=${this.rowCount}
          @input=${this.onInput}
          ${testingAttr(TestingAttrs.textarea)}
        ></textarea>
      </span>
      ${message}
    </div>`;
  }
};
DsfTextarea.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
        flex-grow: 1;
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfTextarea.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTextarea.prototype, "dsf_error", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTextarea.prototype, "dsf_success", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTextarea.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfTextarea.prototype, "readonly", 2);
__decorateClass([
  prop({ type: String })
], DsfTextarea.prototype, "dsf_placeholder", 2);
__decorateClass([
  prop({ type: String })
], DsfTextarea.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String })
], DsfTextarea.prototype, "dsf_name", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfTextarea.prototype, "dsf_resizable", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfTextarea.prototype, "dsf_auto_height", 2);
__decorateClass([
  prop({ type: Number })
], DsfTextarea.prototype, "dsf_rows", 2);
__decorateClass([
  prop({ type: Number })
], DsfTextarea.prototype, "dsf_cols", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfTextarea.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfTextarea.prototype, "autofocus", 2);
__decorateClass([
  prop({ type: String })
], DsfTextarea.prototype, "dsf_message", 2);
__decorateClass([
  preventDefault
], DsfTextarea.prototype, "onInput", 1);
DsfTextarea = __decorateClass([
  defineElement("dsf-textarea")
], DsfTextarea);
export {
  DsfTextarea
};
